module.exports = __webpack_public_path__ + "static/media/s3-bottom-left-5.d3468dd1.png";